//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            showHint: false,
            result: {},
            numFound: 0,
            clickAreas: [
                {
                    x: 55,
                    y: 120,
                    scale: 1.4
                },
                {
                    x: 525,
                    y: 200,
                    scale: 1
                },
                {
                    x: 510,
                    y: 300,
                    scale: 1
                },
                {
                    x: 460,
                    y: 420,
                    scale: 1.3
                },
                {
                    x: 30,
                    y: 590,
                    scale: 1.9
                }
            ]
        };
    }
};
